import { makeStyles } from 'tss-react/mui';

/** Styles for the Sidekick entry card frame, icon slot, and chip row layout. */
const useStyles = makeStyles()((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.new.spacing.small,
    width: '100%',
    padding: theme.new.spacing.medium,
    backgroundColor: theme.new.color.common.white,
    borderRadius: '1rem',
    boxShadow: theme.new.boxShadows.elevation1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  iconSlot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 32,
    height: 32,
    padding: 0,
    border: 0,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: theme.new.color.brand[600],
    cursor: 'pointer',
    '&:focus-visible': {
      outline: `2px solid ${theme.new.color.brand[600]}`,
      outlineOffset: 2,
    },
  },
  title: {
    ...theme.typography.body_medium,
    color: theme.new.color.textPrimary,
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.new.spacing.small,
    width: '100%',
    minWidth: 0,
  },
}));

export default useStyles;
